<template> <!-- OK -->
    <div class="login-container">
        <div class="login-image">
            <img src="../assets/quadra-radio.jpg" alt="Tennis Court">
        </div>
        <div class="login-card">
            <Login/>
        </div>
    </div>
</template>


<script>

    import Login from '../components/Login.vue';

    export default {
        name: 'LoginView',
        components: {
            Login
        }
    }

</script>


<style scoped>

    
    
    .login-container{
        display: flex;
        height: 100vh;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }


    .login-image img{
        width: 50vw;
        height: 100vh;
        object-fit: cover;
    }

    @media(max-width: 425px){
        .login-container{
            flex-direction: column;
            padding: 1rem;
        }

        .login-image{
            display: none;            
        }

        .login-card{
            background: no-repeat center url("../assets/quadra-radio-sem-logo.jpg");
            width: 100vw;
        }

    }


    @media (min-width: 769px){
        .login-container{
            flex-direction: row;
        }

        .login-image img{
            width: 50vw;
            height: 100vh;
        }
    }

    

</style>